module.exports = __webpack_public_path__ + "../resources/img/ic_check_on_p2.4c877364.svg";